export const env = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL ?? '',
  supabaseKey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? '',
  appName: import.meta.env.VITE_APP_NAME || 'Punto de Venta',
  sentryDsn: import.meta.env.VITE_SENTRY_DSN ?? '',
  /** WhatsApp de soporte/cobranza (con código de país, ej. 5491122334455). */
  supportWhatsapp: (import.meta.env.VITE_SUPPORT_WHATSAPP ?? '').replace(/\D/g, ''),
  appVersion: __APP_VERSION__,
};

export const isConfigured = Boolean(env.supabaseUrl && env.supabaseKey);
